import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ISnapshotSignRequest, SnapshotSignRequest } from "@/models/snapshot-sign-request.entity";
import snapshotService from "@/services/mrfiktiv/services/snapshot-sign-request.service";
import { MrfiktivSnapshotSignRequestControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const SnapshotSignRequestPageDataProvider = new (class extends AbstractPageDataProvider<
  ISnapshotSignRequest,
  MrfiktivSnapshotSignRequestControllerFindAllParamsGen
> {
  itemsPerPage = 25;

  async getPage(
    query: MrfiktivSnapshotSignRequestControllerFindAllParamsGen
  ): Promise<IPageViewModel<ISnapshotSignRequest>> {
    const res = await snapshotService.getAll(query);

    const meta = res.meta;
    const data = (res.data ?? []).map(snapshotSignRequest => new SnapshotSignRequest(snapshotSignRequest));

    return { meta, data };
  }
})();
